import React from 'react'
// import Mff from './Exp/Mff'
import Playlist from './Exp/Playlist'


export default function Production() {
    return (
        // why are you looking here lol
        <> 
        <center><br/><br/><p>to everyone who brought these to life, thank you.</p></center>
        <Playlist/>
        </>
    )
}
;
